import { Injectable } from '@angular/core';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
// import { BranchCategoryGridPostParams } from 'common/models/page-models/branch-category-model';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { BatchesModel } from 'common/models/page-models/Batches/batches-data-model';
import { BatchesListingModel } from 'common/models/page-models/Batches/batches-grid-model';
import { BranchCategoryGridPostParams } from 'common/models/page-models/branch-category/branch-category-grid.model';



@Injectable({
    providedIn: 'root'
})
export class BatchesGridDataService extends GridDataService<BatchesListingModel, BatchesModel> {
    constructor(http: SmApiService, protected override ss: SystemService, private datePipe: DatePipe) {
        super(API_URL.batches_grid, http, ss);

    }

    createInstance(): BatchesListingModel {
        return new BatchesListingModel();
    }

    override getGridParams(param): GridPostParams {
        return new BranchCategoryGridPostParams();
    }

    getDeleteUrl() {
        return environment.apiUrl + API_URL.deleteBatch;
    }



    // override transformDataModel(apiRes: any, param) {
    //     super.transformDataModel(apiRes,param);
    //     apiRes[param].forEach(element => {
    //         element.duration_start = this.datePipe.transform(element.duration_start, 'dd/MM/yyyy');
    //         element.duration_end = this.datePipe.transform(element.duration_end, 'dd/MM/yyyy');
    //     });
    //     return apiRes;
    // }

    override transformDataModel(apiRes: any, param) {
        super.transformDataModel(apiRes, param);

        apiRes[param].forEach(element => {
            const start = element.duration_start;
            const end = element.duration_end;
            if (start instanceof Date) {
                element.duration_start = this.datePipe.transform(start, 'dd/MM/yyyy');
            } else if (!isNaN(Date.parse(start))) {
                element.duration_start = this.datePipe.transform(
                    new Date(start),
                    'dd/MM/yyyy'
                );
            } else {
                element.duration_start = start;
            }

            if (end instanceof Date) {
                element.duration_end = this.datePipe.transform(end, 'dd/MM/yyyy');
            } else if (!isNaN(Date.parse(end))) {
                element.duration_end = this.datePipe.transform(
                    new Date(end),
                    'dd/MM/yyyy'
                );
            } else {
                element.duration_end = end;
            }
        });

        return apiRes;
    }


}
